import React from "react";

export default function Skeleton({ className = "" }) {
  return (
    <div
      className={`animate-pulse rounded bg-gray-200 ${className}`}
    />
  );
}